import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-debug-browser',
  templateUrl: './debug-browser.component.html',
  styleUrls: ['./debug-browser.component.scss'],
  standalone: false
})
export class DebugBrowserComponent implements OnInit {
  public navigator = {};

  ngOnInit(): void {
    console.dir(navigator);
    this.copy(navigator, this.navigator);
  }

  copy(source: object, dest: object, seen = new Set()) {
    if (seen.has(source)) {
      return;
    }
    seen.add(source);

    for (const prop in source) {
      if (typeof source[prop]  ==='function') {
        continue;
      } else if (typeof source[prop] === 'object' && source[prop] !== null) {
        const propCopy = {};
        this.copy(source[prop], propCopy, seen);
        dest[prop] = propCopy;
      } else {
        dest[prop] = source[prop];
      }
    }

    const prototypeMethods = Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(source)))
      // filter out getters and setters
      .filter(pair => pair[1].hasOwnProperty('value'))
      .filter(pair => pair[0] !== 'constructor')
      .map(pair => pair[0]);
    if (prototypeMethods.length) {
      dest['PROTO'] = prototypeMethods;
    }
  }
}
